import styled from '@emotion/styled';

export const Content = styled.div`
  padding: 20px 64px;
  max-width: 680px;
  margin: auto;
  @media (max-width: 600px) {
    padding: 0 28px 30px 28px;
  }
`;
